<template>
  <custom-card>
    <template v-slot:title>{{$t('user-lookup.title')}}</template>
    <template v-slot:content>
      <v-sheet color="dark-background">
        <p class="mb-10">
          <i class="info">{{ $t('user-lookup.description') }}</i>
        </p>
        <v-form @submit.prevent="search">
          <v-row justify="center" align="center">
            <v-col>
              <kicklet-text-field
                  v-model="searchField"
                  :label="$t('user-lookup.buttons.name')"
              ></kicklet-text-field>
            </v-col>
            <v-col>
              <kicklet-button
                  class="mb-5"
                  prepend-icon="mdi-magnify"
                  :text="$t('search')"
                  type="submit"
              />
            </v-col>
          </v-row>
        </v-form>
        <div v-if="data">
          <v-card>
            <v-card-title>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="2">
                  <v-avatar :image="data.user.profile_pic" size="96"></v-avatar>
                </v-col>
                <v-col align-self="center">
                  <v-row>
                    <v-col>
                      <div class="name-text">
                        {{ data.user.username }}
                        <v-icon v-if="data.verified" icon="mdi-check-decagram" size="20" color="primary"></v-icon>
                      </div>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-1 mb-5" />
                  <p>{{ data.user.bio }}</p>
                  <v-divider v-if="data.user.bio" class="mt-5" />
                  <v-row class="mt-3">
                    <v-col
                        v-for="(item, i) in items"
                        :key="i"
                        cols="12"
                        sm="4"
                    >
                      <v-list-item class="pa-0">
                        <v-list-item-subtitle>{{ $t(item.title) }}</v-list-item-subtitle>
                        <v-list-item-title>{{ item.value(data) }}</v-list-item-title>
                      </v-list-item>
                    </v-col>
                  </v-row>
                  <v-divider class="mt-5 mb-5" />
                  <v-row>
                    <v-col>
                      <kicklet-button
                          :variant="utils.buttonVariant"
                          color="primary"
                          prepend-icon="mdi-content-copy"
                          :text="$t('user-lookup.buttons.copy-playback-url')"
                          @click="copyPlaybackUrl"
                      />
                    </v-col>
                    <v-col>
                      <kicklet-button
                          :variant="utils.buttonVariant"
                          color="primary"
                          prepend-icon="mdi-open-in-new"
                          :text="$t('user-lookup.buttons.visit-on-kick')"
                          @click="openKickPage"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </div>
        <p v-else-if="error">
          {{ $t('user-lookup.user-not-found') }}
        </p>
      </v-sheet>
    </template>
  </custom-card>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Kick } from '@/services/Kick';
import { Utils } from '@/modules/utils';
import { Analytics } from '@/services/Analytics';
import CustomCard from '@/components/custom/CustomCard.vue';
import KickletButton from '@/components/custom/kicklet/KickletButton.vue';
import KickletTextField from '@/components/custom/kicklet/KickletTextField.vue';

const router = useRouter();
const route = useRoute();
const searchField = ref(null);
const data = ref(null);
const error = ref(null);

const items = [
  {
    title: 'user-lookup.follow',
    value: (data) => data.followers_count,
  },
  {
    title: 'user-lookup.created-at',
    value: (data) => Utils.formatDateTime(data.chatroom.created_at, 'LL'),
  },
  {
    title: 'user-lookup.verified',
    value: (data) => data.verified,
  },
  {
    title: 'user-lookup.id',
    value: (data) => data.id,
  },
  {
    title: 'user-lookup.user-id',
    value: (data) => data.user_id,
  },
  {
    title: 'user-lookup.is-banned',
    value: (data) => data.is_banned,
  },
];

function search () {
  router.push({ name: route.name, params: { streamer: searchField.value } });
  loadData();
  Analytics.event('user_lookup', { user: searchField.value });
}

function openKickPage () {
  const url = 'https://kick.com/' + data.value.user.username;
  window.open(url, '_blank');
}

function copyPlaybackUrl () {
  navigator.clipboard.writeText(data.value.playback_url);
}

function loadData () {
  Kick.getStreamerData(searchField.value)
    .then((r) => {
      data.value = r;
    })
    .catch(() => {
      data.value = null;
      error.value = true;
    });
}

onMounted(() => {
  if (route.params.streamer) {
    searchField.value = route.params.streamer;
    loadData();
  }
});
</script>

<style scoped>
.name-text {
  font-size: 28px;
}
</style>
